import { styled } from 'goober';
import { forwardRef } from 'react';
import { Button } from './Basic';
export var BtnIcon = styled('span')(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: theme.font.smallSize,
        marginRight: theme.space.s,
        display: 'inline-flex',
    });
});
export var BtnFlex = styled('div')(function () {
    return {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
    };
});
export var IconBgButton = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: theme.font.smallSize,
        marginRight: theme.space.s,
        backgroundColor: theme.colors.neutral.w100,
        borderRadius: '4px',
        minWidth: '32px',
        minHeight: '32px',
        display: 'inline-flex',
        cursor: 'pointer',
        alignItems: 'center',
        justifyContent: 'center',
    });
});
export var PrimaryButton = styled(Button)(function (_a) {
    var theme = _a.theme;
    return ({
        color: '#fff',
        backgroundColor: theme.colors.primary.w500,
        borderColor: theme.colors.primary.w500,
        '&:hover': {
            backgroundColor: theme.colors.primary.w700,
            borderColor: theme.colors.primary.w700,
        },
    });
});
export var InvertedButton = styled(Button)(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.colors.primary.w500,
        backgroundColor: '#fff',
        borderColor: theme.colors.primary.w500,
        '&:hover': {
            color: theme.colors.primary.w700,
            borderColor: theme.colors.primary.w700,
        },
    });
});
